const cookieInformationElem = document.querySelector('#cookies-information');
let checkboxEls;
let cookieBannerReOpened = false;
export const STORAGE_KEY = 'hatchery_acceptedCookies';
export const EVENT_ACCEPTED_COOKIES_CHANGED = 'hatchery_acceptedCookiesChanged';
export var COOKIE_TYPE;
(function (COOKIE_TYPE) {
    COOKIE_TYPE["REQUIRED"] = "required";
    COOKIE_TYPE["GOOGLE_MAPS"] = "google-maps";
})(COOKIE_TYPE || (COOKIE_TYPE = {}));
export function setAcceptedCookies(cookies) {
    // Remove duplicates, include required cookies by default
    cookies = Array.from(new Set([...cookies, COOKIE_TYPE.REQUIRED]));
    const cookiesChanged = JSON.stringify(getAcceptedCookies()) !== JSON.stringify(cookies);
    // Persist in a cookie
    window.localStorage.setItem(STORAGE_KEY, cookies.join(','));
    // Mark respective checkboxes as checked
    updateCheckboxState();
    hideCookieBanner();
    window.dispatchEvent(new CustomEvent(EVENT_ACCEPTED_COOKIES_CHANGED, {
        detail: { acceptedCookies: cookies },
    }));
    if (cookieBannerReOpened && cookiesChanged) {
        window.location.reload();
    }
}
export function getAcceptedCookies() {
    try {
        return window.localStorage.getItem(STORAGE_KEY)?.split(',');
    }
    catch (e) {
        return [COOKIE_TYPE.REQUIRED];
    }
}
function updateCheckboxState() {
    const cookies = getAcceptedCookies();
    if (cookies && checkboxEls) {
        checkboxEls.forEach(checkboxEl => (checkboxEl.checked = cookies.includes(checkboxEl.value)));
    }
}
const PATHS_HIDE_BANNER = [/privacy/, /datenschutz/, /privacy-policy/];
// Setup cookiebanner events
function setup() {
    window.hatchery = window.hatchery ?? {};
    window.hatchery.cookies = window.hatchery.cookies ?? {};
    window.hatchery.cookies.initialized = true;
    if (!cookieInformationElem) {
        return;
    }
    const checkboxEls = Array.from(cookieInformationElem.querySelectorAll('.checkboxes-container input'));
    updateCheckboxState();
    // Logic to only activate selected cookies
    cookieInformationElem.querySelector('#btn-accept-selected')?.addEventListener('click', () => {
        const acceptedCookieTypes = Array.from(checkboxEls)
            .map(el => (el.checked ? el.value : null))
            .filter(val => !!val);
        setAcceptedCookies(acceptedCookieTypes);
        window.dataLayer.push({ event: 'cookies_btn_accept_selected_clicked' });
    });
    cookieInformationElem.querySelector('#btn-accept-all')?.addEventListener('click', () => {
        setAcceptedCookies(Object.values(COOKIE_TYPE));
        window.dataLayer.push({ event: 'cookies_btn_accept_all_clicked' });
    });
    cookieInformationElem.querySelector('#btn-accept-required')?.addEventListener('click', () => {
        setAcceptedCookies([COOKIE_TYPE.REQUIRED]);
        window.dataLayer.push({ event: 'cookies_btn_accept_required_clicked' });
    });
    // Show popup if user is trying to unselect the required option
    cookieInformationElem
        .querySelector('label[for="required-cookies"]')
        ?.addEventListener('click', function () {
        alert(this.title);
    });
    if (window.localStorage.getItem(STORAGE_KEY)) {
        const acceptedCookies = window.localStorage.getItem(STORAGE_KEY)?.split(',');
        setAcceptedCookies(acceptedCookies);
    }
    else {
        const { pathname } = window.location;
        const bannerHiddenDuePath = PATHS_HIDE_BANNER.some(condition => {
            if (typeof condition === 'string') {
                return pathname.includes(condition);
            }
            else {
                condition.test(pathname);
            }
        });
        if (bannerHiddenDuePath) {
            hideCookieBanner();
        }
        else {
            showCookieBanner();
        }
    }
}
export function showCookieBanner() {
    if (cookieInformationElem) {
        cookieInformationElem.style.display = 'flex';
    }
}
export function hideCookieBanner() {
    if (cookieInformationElem) {
        cookieInformationElem.style.display = 'none';
    }
}
// Setup dataLayer
window.dataLayer = window.dataLayer || [];
// Ensure setup code only runs once
window.hatchery = window.hatchery ?? {};
window.hatchery.cookies = window.hatchery.cookies ?? {};
if (window.hatchery?.cookies?.initialized !== true) {
    setup();
}
// Listen to clicks on links to open the cookie banner
document.querySelectorAll('[href="#cookie-banner"]').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        cookieBannerReOpened = true;
        showCookieBanner();
    });
});
// Google Maps accept cookies buttons
function acceptGoogleMapsCookies() {
    const cookies = getAcceptedCookies();
    setAcceptedCookies([...cookies, COOKIE_TYPE.GOOGLE_MAPS]);
}
window.addEventListener('DOMContentLoaded', () => {
    const gmCookieButtons = document.querySelectorAll('.btn-accept-google-maps-cookies');
    gmCookieButtons.forEach(btn => btn.addEventListener('click', acceptGoogleMapsCookies));
});
